import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'tab-content',
  props: {
  value: {},
  text: {},
  item: {
    type: Object,
    default: () => ({ key: "", type: "unit", unit: "px" })
  },
  default_value: {},
  disabled: Boolean,
  trans: {
    required: true
  },
  mapId: {
    required: true
  }
},
  emits: ["input"],
  setup(__props, { emit }) {

const props = __props



const form = computed({
  get() {
    if (props.value != null) return props.value;
    return props.default_value;
  },
  set(value) {
    emit("input", value);
  }
});
const attrs = computed(() => {
  if (!props.item || !props.item.props || !props.item.props.content) {
    return {};
  }
  if (typeof props.item.props.content == "function") {
    return props.item.props.content(props.item);
  }
  return props.item.props.content;
});
const onSetDefaultValue = () => {
  form.value = props.default_value;
};

return { __sfc: true,props, emit, form, attrs, onSetDefaultValue }
}

})